import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const Input: React.FC<InputProps> = ({ label, error, className = "", ...rest }) => {
  return (
    <div className="flex flex-col">
      {label && (
        <label className="mb-1 text-sm font-medium text-subTitleText">
          {label}
        </label>
      )}
      <input
        className={`w-full border border-borderColor rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary transition ${className} ${
          error ? "border-errorText" : ""
        }`}
        {...rest}
      />
      {error && (
        <span className="mt-1 text-errorText text-sm">
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
